import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "percentual"
})
export class PercentualPipe implements PipeTransform {
    transform(value: number, ...args: any[]): string {
        return `${Math.round(value).toString()}%`;
    }
}
